/* ==================== INIT ==================== */
document.addEventListener('preloader:done', function() {
    initAnimations();
});

/* ==================== MAIN ==================== */
function initAnimations() {

    gsap.registerPlugin(ScrollTrigger);

    /* Header */
    const header = document.querySelector('.header');
    let lastY = 0;
    window.addEventListener('scroll', () => {
        const y = window.scrollY;
        header.style.background = y > 100 ? 'rgba(24,24,27,0.35)' : 'rgba(24,24,27,0.2)';
        header.style.borderColor = y > 100 ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.1)';
        header.style.transform = (y > lastY && y > 500)
            ? 'translateX(-50%) translateY(-120%)'
            : 'translateX(-50%) translateY(0)';
        lastY = y;
    });

    /* Smooth scroll */
    document.querySelectorAll('a[href^="#"]').forEach(a => {
        a.addEventListener('click', function(e) {
            const h = this.getAttribute('href');
            if (h === '#') return;
            e.preventDefault();
            const t = document.querySelector(h);
            if (t) t.scrollIntoView({ behavior: 'smooth' });
        });
    });

    /* ==================== HERO + TRUST (immediate) ==================== */
    gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.header', { y: -60, opacity: 0, duration: 0.5 })
        .from('.hero__badge', { y: 15, opacity: 0, duration: 0.4, scale: 0.95 }, '-=0.2')
        .from('.hero__title', { y: 30, opacity: 0, duration: 0.5 }, '-=0.2')
        .from('.hero__subtitle', { y: 15, opacity: 0, duration: 0.4 }, '-=0.3')
        .from('.hero__desc', { y: 15, opacity: 0, duration: 0.4 }, '-=0.25')
        .from('.hero__btns', { y: 15, opacity: 0, duration: 0.4 }, '-=0.2')
        .from('.hero__scroll', { opacity: 0, duration: 0.5 }, '-=0.15')
        .from('.trust__item', { y: 20, opacity: 0, duration: 0.4, stagger: 0.06 }, '-=0.3');

    /* Trust counters */
    document.querySelectorAll('.trust__value').forEach(el => {
        const text = el.textContent;
        const match = text.match(/^([\d,]+)/);
        if (!match) return;
        const target = parseInt(match[1].replace(/,/g, ''));
        const suffix = text.replace(match[1], '');
        const obj = { val: 0 };
        gsap.to(obj, {
            val: target, duration: 2.5, delay: 1.5, ease: 'power2.out',
            onUpdate: () => { el.textContent = Math.floor(obj.val).toLocaleString() + suffix; }
        });
    });

    /* ==================== SCROLL REVEAL ==================== */
    /*
     * gsap.set() hides elements immediately
     * ScrollTrigger onEnter animates them in
     * Each element is its own trigger = fires when IT enters viewport
     */

    function reveal(targets, opts = {}) {
        const els = gsap.utils.toArray(targets);
        if (!els.length) return;

        /* Hide all immediately */
        gsap.set(els, {
            opacity: 0,
            y: opts.y ?? 50,
            x: opts.x ?? 0,
            scale: opts.scale ?? 1,
        });

        /* Reveal each when it enters viewport */
        els.forEach((el, i) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 93%',
                once: true,
                onEnter: () => {
                    gsap.to(el, {
                        opacity: 1, y: 0, x: 0, scale: 1,
                        duration: opts.duration ?? 0.8,
                        delay: (opts.stagger ?? 0) * i,
                        ease: opts.ease || 'power3.out',
                    });
                }
            });
        });
    }

    /* Lewis */
    reveal('.lewis .section-tag, .lewis__title, .lewis__sub', { stagger: 0.1 });
    reveal('.lewis__card', { y: 70, stagger: 0.12, scale: 0.97 });

    /* Nucular */
    reveal('.nucular__img', { x: -70, y: 0, duration: 1 });
    reveal('.nucular__text > *', { x: 50, y: 0, duration: 0.7, stagger: 0.08 });

    /* Grid2 */
    reveal('.grid2__header > *', { stagger: 0.08 });
    reveal('.grid2 .product-card', { y: 60, stagger: 0.1, scale: 0.96 });

    /* Swing */
    reveal('.swing__content > *', { y: 35, duration: 0.7, stagger: 0.08 });
    reveal('.swing__panel-item', { x: 50, y: 0, duration: 0.7, stagger: 0.1 });

    /* Track */
    reveal('.track__header > *', { stagger: 0.08 });
    reveal('.track__card', { y: 60, stagger: 0.12, scale: 0.96 });

    /* Grid3 */
    reveal('.grid3__header > *', { stagger: 0.08 });
    reveal('.grid3 .product-card', { y: 60, stagger: 0.08, scale: 0.96 });

    /* Compat */
    reveal('.compat__title, .compat__sub', { stagger: 0.08 });
    reveal('.compat__card', { y: 40, scale: 0.92, duration: 0.7, stagger: 0.06, ease: 'back.out(1.4)' });

    /* Finger */
    reveal('.finger__img', { x: -80, y: 0, duration: 1 });
    reveal('.finger__text > *', { x: 50, y: 0, duration: 0.7, stagger: 0.06 });

    /* About */
    reveal('.about__inner > *', { stagger: 0.1, duration: 0.8 });

    /* Reviews */
    reveal('.reviews__header > *', { stagger: 0.08 });
    reveal('.review-card', { y: 50, stagger: 0.06, scale: 0.96 });

    /* CTA */
    reveal('.cta__content > *', { stagger: 0.08, duration: 0.8 });

    /* Footer */
    reveal('.footer__top > *', { y: 25, stagger: 0.08, duration: 0.7 });

    /* Section tag line */
    document.querySelectorAll('.section-tag').forEach(tag => {
        ScrollTrigger.create({
            trigger: tag, start: 'top 93%', once: true,
            onEnter: () => tag.classList.add('is-visible')
        });
    });

    /* Parallax */
    document.querySelectorAll('.hero__bg img, .swing__bg img, .cta__bg img, .about__bg img').forEach(img => {
        const p = img.closest('section') || img.closest('.hero') || img.parentElement.parentElement;
        if (!p) return;
        gsap.to(img, {
            scrollTrigger: { trigger: p, start: 'top bottom', end: 'bottom top', scrub: 1.5 },
            y: 80, ease: 'none'
        });
    });

    /* Magnetic buttons */
    document.querySelectorAll('.btn').forEach(btn => {
        btn.addEventListener('mousemove', e => {
            const r = btn.getBoundingClientRect();
            gsap.to(btn, {
                x: (e.clientX - r.left - r.width/2) * 0.12,
                y: (e.clientY - r.top - r.height/2) * 0.12,
                duration: 0.3, ease: 'power2.out'
            });
        });
        btn.addEventListener('mouseleave', () => {
            gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1,0.5)' });
        });
    });

    /* Card tilt (NO track cards) */
    document.querySelectorAll('.product-card, .lewis__card, .compat__card').forEach(c => {
        c.addEventListener('mousemove', e => {
            const r = c.getBoundingClientRect();
            gsap.to(c, {
                rotateY: ((e.clientX-r.left)/r.width - 0.5) * 5,
                rotateX: -((e.clientY-r.top)/r.height - 0.5) * 5,
                duration: 0.4, ease: 'power2.out', transformPerspective: 800
            });
        });
        c.addEventListener('mouseleave', () => {
            gsap.to(c, { rotateY: 0, rotateX: 0, duration: 0.6, ease: 'power3.out' });
        });
    });

    /* Cursor glow on cards */
    document.querySelectorAll('.product-card--dark, .lewis__card, .track__card, .review-card, .compat__card').forEach(c => {
        c.addEventListener('mousemove', e => {
            const r = c.getBoundingClientRect();
            c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
            c.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
    });

    /* Hero cursor glow */
    const hero = document.querySelector('.hero');
    if (hero) {
        const g = document.createElement('div');
        g.style.cssText = 'position:absolute;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(124,58,237,0.06) 0%,transparent 70%);pointer-events:none;transform:translate(-50%,-50%);z-index:0;opacity:0;transition:opacity 0.4s';
        hero.appendChild(g);
        hero.addEventListener('mousemove', e => {
            const r = hero.getBoundingClientRect();
            g.style.left = (e.clientX - r.left) + 'px';
            g.style.top = (e.clientY - r.top) + 'px';
            g.style.opacity = '1';
        });
        hero.addEventListener('mouseleave', () => { g.style.opacity = '0'; });
    }
}

/* ==================== QUICK ADD ==================== */
(function() {
    /* Modal DOM */
    var overlay = document.createElement('div');
    overlay.className = 'spark-qa-overlay';
    overlay.innerHTML =
        '<div class="spark-qa-modal">' +
            '<button class="spark-qa-close" aria-label="Close">' +
                '<svg width="20" height="20" viewBox="0 0 18 18" fill="none"><path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<div class="spark-qa-body"></div>' +
        '</div>';
    document.body.appendChild(overlay);

    /* Load initial cart count */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var badge = document.querySelector('.header__cart-count');
        if (badge && cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = 'flex';
        }
    });

    var modalBody = overlay.querySelector('.spark-qa-body');

    function openModal() {
        overlay.classList.add('spark-qa-open');
        document.body.style.overflow = 'hidden';
    }
    function closeModal() {
        overlay.classList.remove('spark-qa-open');
        document.body.style.overflow = '';
    }

    overlay.querySelector('.spark-qa-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keyup', function(e) { if (e.key === 'Escape') closeModal(); });

    /* Format price */
    function fmtPrice(cents) {
        return '$' + (parseFloat(cents) || 0).toFixed(2).replace(/\.00$/, '');
    }

    /* Add to cart via AJAX */
    function addToCart(variantId, qty) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty || 1 })
        }).then(function(r) { return r.json(); });
    }

    /* Show success feedback */
    function showAdded(btn) {
        var orig = btn.textContent;
        btn.textContent = 'Added!';
        btn.style.opacity = '0.7';
        setTimeout(function() {
            btn.textContent = orig;
            btn.style.opacity = '';
        }, 1500);
    }

    /* Find variant by selected options */
    function findVariant(variants, selected) {
        for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var match = true;
            for (var j = 0; j < selected.length; j++) {
                if (v['option' + (j + 1)] !== selected[j]) { match = false; break; }
            }
            if (match) return v;
        }
        return variants[0];
    }

    /* Render Choose Options modal */
    function renderModal(product) {
        var img = product.images && product.images[0] ? product.images[0].src || product.images[0] : '';
        var html = '<h2 class="spark-qa-heading">Choose options</h2>';
        html += '<div class="spark-qa-product">';

        /* Image + info row */
        html += '<div class="spark-qa-header">';
        if (img) html += '<img class="spark-qa-img" src="' + img + '" alt="' + product.title + '">';
        html += '<div class="spark-qa-info">';
        html += '<h3 class="spark-qa-title">' + product.title + '</h3>';
        html += '<p class="spark-qa-price" id="spark-qa-price">' + fmtPrice(product.variants[0].price) + '</p>';
        html += '<p class="spark-qa-tax">Tax included. <a href="/pages/shipping-policy">Shipping</a> calculated at checkout.</p>';
        html += '<a class="spark-qa-details" href="/products/' + product.handle + '">View details</a>';
        html += '</div></div>';

        /* Option selectors */
        product.options.forEach(function(opt, idx) {
            html += '<div class="spark-qa-option">';
            html += '<label class="spark-qa-label">' + opt.name + '</label>';
            html += '<div class="spark-qa-select-wrap">';
            html += '<select class="spark-qa-select" data-option-index="' + idx + '">';
            opt.values.forEach(function(val) {
                html += '<option value="' + val + '">' + val + '</option>';
            });
            html += '</select>';
            html += '<svg class="spark-qa-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
            html += '</div></div>';
        });

        /* Quantity + Add to cart */
        html += '<div class="spark-qa-actions">';
        html += '<div class="spark-qa-qty">';
        html += '<button class="spark-qa-qty-btn" data-action="minus">-</button>';
        html += '<input class="spark-qa-qty-input" type="number" value="1" min="1">';
        html += '<button class="spark-qa-qty-btn" data-action="plus">+</button>';
        html += '</div>';
        html += '<button class="spark-qa-add">Add to cart</button>';
        html += '</div>';

        html += '</div>';
        modalBody.innerHTML = html;

        /* Variant tracking */
        var selects = modalBody.querySelectorAll('.spark-qa-select');
        var priceEl = modalBody.querySelector('#spark-qa-price');
        var addBtn = modalBody.querySelector('.spark-qa-add');
        var qtyInput = modalBody.querySelector('.spark-qa-qty-input');

        function getSelected() {
            var vals = [];
            selects.forEach(function(s) { vals.push(s.value); });
            return vals;
        }

        function updatePrice() {
            var v = findVariant(product.variants, getSelected());
            if (v) priceEl.textContent = fmtPrice(v.price);
        }

        selects.forEach(function(s) { s.addEventListener('change', updatePrice); });

        /* Qty buttons */
        modalBody.querySelector('[data-action="minus"]').addEventListener('click', function() {
            var v = parseInt(qtyInput.value) || 1;
            if (v > 1) qtyInput.value = v - 1;
        });
        modalBody.querySelector('[data-action="plus"]').addEventListener('click', function() {
            qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
        });

        /* Add to cart */
        addBtn.addEventListener('click', function() {
            var v = findVariant(product.variants, getSelected());
            if (!v) return;
            addBtn.textContent = 'Adding...';
            addBtn.disabled = true;
            addToCart(v.id, parseInt(qtyInput.value) || 1).then(function() {
                addBtn.textContent = 'Added!';
                fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                    var badge = document.querySelector('.header__cart-count');
                    if (badge && cart.item_count > 0) {
                        badge.textContent = cart.item_count;
                        badge.style.display = 'flex';
                    }
                });
                setTimeout(closeModal, 800);
            }).catch(function() {
                addBtn.textContent = 'Error';
                setTimeout(function() { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; }, 1500);
            });
        });

        openModal();
    }

    /* Button click handler */
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.spark-quick-add');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        var url = btn.getAttribute('data-product-url');
        if (!url) return;

        btn.style.opacity = '0.6';
        btn.style.pointerEvents = 'none';

        fetch(url + '.json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                var product = data.product;
                var isSingle = product.options.length === 1 && product.options[0].name === 'Title';

                if (isSingle) {
                    /* Single variant - add to cart then redirect to product */
                    addToCart(product.variants[0].id, 1).then(function() {
                        showAdded(btn);
                        setTimeout(function() {
                            window.location.href = '/products/' + product.handle;
                        }, 600);
                    }).catch(function() {
                        window.location.href = '/products/' + product.handle;
                    });
                } else {
                    /* Multiple variants - show modal */
                    renderModal(product);
                }
            })
            .catch(function() {
                window.location.href = url;
            })
            .finally(function() {
                btn.style.opacity = '';
                btn.style.pointerEvents = '';
            });
    });
})();
